/**
 * Tờ thu tiền, khách chuyển khoản mà tiệm CHƯA khai tài khoản nhận tiền (v0.23.2, L4-04, docs/plans/tai-khoan-nhan-tien-the-rieng.md).
 * Chủ tiệm (`onKhai` có): câu giải thích + MỘT nút "Khai tài khoản nhận tiền" (đóng tờ thu, mở Cấu hình → Cài đặt tiệm, cuộn tới thẻ).
 * Vai khác (quản lý, lễ tân, KTV tự thu) không khai được: chỉ câu nhờ chủ tiệm, không nút.
 */
import { G } from './text/goi-vi.ts'
import { ThongBao } from './ui.tsx'

export function QrChuaCoTaiKhoan({ onKhai }: { onKhai?: () => void }) {
  if (onKhai === undefined) return <ThongBao loai="canh-bao">{G.qrNoAccountAsk}</ThongBao>
  return (
    <>
      <ThongBao loai="canh-bao">{G.qrNoAccount}</ThongBao>
      <button type="button" className="nut nut-vien" onClick={onKhai}>
        {G.qrNoAccountBtn}
      </button>
    </>
  )
}
